import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = ["content"];

  //読み込み時
  initialize() {
    $(".js-radio-toggle-commission-panel").hide();
    $(".js-radio-toggle-commission-panel#credit").show();

    this.panelShow();
  }

  change(e) {
    e.preventDefault();
    this.panelShow();
  }

  panelShow() {
    this.contentTargets.forEach((element) => {
      var trigger = $(element);

      if (trigger.is(":checked")) {
        const targetToggle = trigger.closest(".js-radio-toggle");
        const targetPanel = targetToggle.next(".js-radio-toggle-panel");
        const targetCommission = $(".js-radio-toggle-commission-panel#" + trigger.val());

        // ターゲット以外のトグルを閉じる
        $(".js-radio-toggle").not(targetToggle).removeClass("is-open");
        $(".js-radio-toggle-panel").not(targetPanel).slideUp();
        // aria属性
        $(".js-radio-toggle-trigger").not(trigger);
        $(".js-radio-toggle-panel").not(targetPanel);

        // 選択されたラジオボタンのトグルを開く
        targetToggle.addClass("is-open");
        targetPanel.slideDown();

        // 選択された決済方法に応じて手数料エリアの表示・非表示
        // 合計金額の更新
        $(".js-radio-toggle-commission-panel").not(targetCommission).hide();
        targetCommission.show();
      }
    });
  }
}
